export function htmlStartingAtHash(html: string) {
  throw new Error('htmlStartingAtHash called on the client!');
}
